import { debounce, getViewportHeight } from './libs/dom'
import Filtering from './modules/Filtering'
import Info from './modules/Info'
import LangToggle from './modules/LangToggle'
import Marquee from './modules/Marquee'
import Menu from './modules/Menu'
import Modals from './modules/Modals'
import ScrollAnimation from './modules/ScrollAnimation'
import Select from './modules/Select'
import Slider from './modules/Slider'
import Ticketing from './modules/Ticketing'

getViewportHeight()
const debouncedResize = debounce(getViewportHeight)
window.addEventListener('resize', debouncedResize)

new Slider()
new Modals()
new Marquee()
new Menu()
new LangToggle()
new ScrollAnimation()
new Info()
new Filtering()
new Ticketing()

const invitation = document.querySelector('.s-invitation')

if (invitation) {
  const ctaGhost = document.querySelector('[data-modal="enviso"]')
  ctaGhost.click()
}

new Select()
